import React from 'react';


const ContentDeleted = () => {
  return (
    <div>
      <div className="container container-max">
        <div className="row">
          <div className="col-md-12 mt-3 notfound mt-5 mb-5">
            <h1 className="fw-bold">410 - This Page Is No Longer Available.</h1>
            <p>
              The page you are trying to access has been permanently removed
              from our publication.
            </p>

            {/* <div className="mt-4 mb-4"> */}
            <p>
              To get the best out of this experience, click to browse our{" "}
              <a href="/topic/featured" className="pRed">
                Latest Articles,
              </a>{" "}
              or you could also visit the{" "}
              <a href="/" className="pRed">
                Homepage.
              </a>
            </p>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentDeleted;